import React from "react";

function Stats() {
  const stats = [
    { number: "100+", label: "Lives Impacted" },
    { number: "10+", label: "Projects Completed" },
  ];

  return (
    <section style={styles.container}>
      <div style={styles.grid}>
        {stats.map((stat, index) => (
          <div key={index} style={styles.card}>
            <h1 style={styles.number}>{stat.number}</h1>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    background: "#19195f",
    color: "white",
    padding: "60px 20px"
  },
  grid: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap"
  },
  card: {
    textAlign: "center",
    margin: "20px"
  },
  number: {
    fontSize: "40px",
    fontWeight: "bold"
  }
};

export default Stats;